var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTelegramFullcolor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.31543,
    width: 20,
    height: 20,
    rx: 10,
    fill: "url(#paint0_linear_149_14727)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.84227 9.89446C7.75748 8.62435 9.7014 7.78702 10.6741 7.38246C13.4512 6.22737 14.0282 6.02672 14.4043 6.02009C14.4871 6.01863 14.672 6.03913 14.7918 6.13635C14.893 6.21844 14.9208 6.32934 14.9342 6.40717C14.9475 6.485 14.9641 6.6623 14.9509 6.80083C14.8004 8.38207 14.1492 12.2193 13.8179 13.9903C13.6777 14.7397 13.4017 14.991 13.1345 15.0155C12.5538 15.069 12.1128 14.6318 11.5504 14.2631C10.6702 13.6861 10.173 13.327 9.31871 12.764C8.33139 12.1134 8.97143 11.7558 9.53409 11.1714C9.68135 11.0184 12.24 8.69115 12.2895 8.48002C12.2957 8.45362 12.3015 8.3552 12.243 8.30323C12.1845 8.25125 12.0982 8.26903 12.036 8.28316C11.9477 8.3032 10.5417 9.23252 7.8179 11.0711C7.4188 11.3452 7.05731 11.4787 6.73343 11.4717C6.37638 11.464 5.68956 11.2698 5.17898 11.1039C4.55272 10.9003 4.05499 10.7927 4.09833 10.4469C4.12091 10.2669 4.36889 10.0827 4.84227 9.89446Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_149_14727",
    x1: 10.3154,
    y1: 0,
    x2: 10.3154,
    y2: 19.8517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelegramFullcolor);
export default __webpack_public_path__ + "static/media/icon-telegram-fullcolor.41916170a6342217f8fade3e9764c8e2.svg";
export { ForwardRef as ReactComponent };